/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

type Props = {
  color?: string;
  padding?: '--cds-spacing-50' | '--cds-spacing-100';
};

const styles = {
  dot: (color?: string, padding = '--cds-spacing-100') => css`
    padding: 0 var(${padding});
    color: ${color ?? 'inherit'};
  `,
};

/**
 * A visual dot separator between content items.
 * The dot and surrounding padding are hidden from screen readers,
 * but whitespace is preserved for natural text separation.
 */
const DottedSeparator = ({ color, padding }: Props) => {
  return (
    <React.Fragment>
      <span aria-hidden="true" css={styles.dot(color, padding)}>
        &#x2022;
      </span>
      {/* Whitespace for screen reader separation */}{' '}
    </React.Fragment>
  );
};

export default DottedSeparator;
